import { reactive, computed } from 'vue'
import { Store } from 'vuex'
import { Router } from 'vue-router'
import { State as StoreState } from '@/store/index'
import * as log from '@/model/util/log/Logger'
import { ErrorMsgState, useErrorMsg, useErrorMsgString } from '@/model/components/common/message/errorMessage'
import { userDownload } from '@/model/api/user/apiUserDownload'
import { useStoreAction } from '@/model/store/store'
import * as Screen from '@/store/stateScreen'
import { useRouterUtil } from '@/model/router/router'
import { DownloadDetailData } from '@/model/router/routerType'
import { focusBlur } from '@/model/util/dom/domUtil'
import { DownloadSearchState } from './userDownloadSearchState'

/**
 * 失敗メッセージの取得有無
 * @param props 初期データ
 * @returns 失敗メッセージの取得有無
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const isFail = (props: any) => !!props.failmsg

/**
 * ダウンロード検索画面の初期状態を取得する
 * @param props 初期データ
 * @param store vuex
 * @returns 初期状態、エラー情報、エラー情報有無
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const useDownloadSearch = (props: any, store: Store<StoreState>) => {
  // 状態
  const state = reactive<DownloadSearchState>({
    loading: false,
    key: props.searchkey,
  })
  // エラー情報
  const errorState = store.state.screen.download.error
  // エラー情報有無
  const isError = computed(() => errorState.data.length !== 0)
  // 失敗メッセージ用エラー情報
  const errorFailState = isFail(props) ? useErrorMsgString(props.failmsg) : useErrorMsg()

  return { state, errorState, isError, errorFailState }
}

/**
 * ダウンロードキーのクリア
 * @param state 画面状態
 */
const clear = (state: DownloadSearchState) => {
  state.key = ''
}

/**
 * メール情報検索処理を実施する
 * @param state 画面状態
 * @param store vuex
 * @param router vueRouter
 * @param error エラーメッセージ状態
 * @param errorFail 失敗エラーメッセージ状態
 * @param failClear 詳細画面の失敗メッセージの表示有無
 */
const search = async (
  state: DownloadSearchState,
  store: Store<StoreState>,
  router: Router,
  error: ErrorMsgState,
  errorFail: ErrorMsgState,
  failClear: boolean
) => {
  // 一旦メッセージを全て初期化
  error.data.splice(0)
  errorFail.data.splice(0)
  // モバイルのためにfocusを外す
  focusBlur()
  // ローディングがONの場合は実行中とみなして何もしない
  if (state.loading) {
    log.debug(`Already running. [search]`)
    return
  }
  // ローディングをONにする
  state.loading = true
  // 詳細情報をクリア
  await useStoreAction(store).downloadDetailInit()
  // api送信を実施
  const { normaldata } = await userDownload(router, store).search(state.key, error)
  // ローディングをOFFにする
  state.loading = false
  if (normaldata) {
    // 検索成功した場合は、vuexに検索情報を設定する
    const data: Screen.DonwloadDetail = {
      key: state.key,
      senddate: normaldata.senddate,
      from: normaldata.from,
      subject: normaldata.subject,
      size: normaldata.size,
      attached: normaldata.attached,
      dispAttached: normaldata.dispAttached,
      dispEml: normaldata.dispEml,
      isFail: failClear,
    }
    log.debug(`state save. data:${JSON.stringify(data)}`)
    await useStoreAction(store).downloadDetail(data)
    // 詳細画面のURLに遷移する
    const input: DownloadDetailData = {
      downloadKey: state.key,
      search: 'false',
    }
    useRouterUtil(router).downlaodDetail(input)
  }
}

export { useDownloadSearch, clear, search, isFail }
